import { RouterModule, Routes } from '@angular/router';
import { NgModule } from '@angular/core';
import { FeedCommentsPageComponent } from './comments-page.component';
import { canActivateWithAccessGuard } from '@/app/core/auth/access-guard';
import { atLeastGroupAdmin } from '@/app/core/auth/auth-pipes';

const routes: Routes = [
  { path: '', component: FeedCommentsPageComponent, ...canActivateWithAccessGuard(atLeastGroupAdmin) },
];

@NgModule({
  exports: [RouterModule],
  imports: [RouterModule.forChild(routes)],
})
export class FeedCommentsRoutingModule {}
